
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hOVIX", function(module, exports) {
var $0a8f0e83dcf5160a$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 extends Error {
}
class $0a8f0e83dcf5160a$export$627bc00a5ef5f6ae extends Error {
}
class $0a8f0e83dcf5160a$export$66e065cfeb491a4d extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof $0a8f0e83dcf5160a$export$66e065cfeb491a4d;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $0a8f0e83dcf5160a$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $0a8f0e83dcf5160a$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(args){
        /**
     * It is expected that this error message can be not deterministic.
     * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
     * Showing the error cause helps them understand what was the problem with their payload.
     *
     * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
     * to distinguish between message makers code errors and platform errors,
     * but we don't rely on the error message itself.
     */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.function = void 0;
        this.messageTemplateId = void 0;
        this.triggerId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2833d4759f81601b extends $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = 'Invalid CSS property could not be processed by Juice';
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8d39b103586e9fd4 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$f649da38897d27f7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c2852c1c4d9aba3e extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4b7b4e09547e4bb3 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$360a094a97597d87 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4d068b43eb55165b extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ac007ee150add337 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$19cb89dd679394cb extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$78651662ad470cc5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8a5041670cdd8db2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(journeyId){
        super('Journey not found', "JourneyNotFoundError"), this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1240ddc25cf964e6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3c4884b7ae7fe517 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$913b8e68dc7ae8fe extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e5ccdf8bbfead7a2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$823733742d803ae6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1caa32527f23acd2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.errorCause = void 0;
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$a6f2aad8fa094b39 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2296e5dc6a1bf3d2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Gateway timeout occurred', "GatewayTimeoutError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2f1e27130c2bf271 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.payloadSize = void 0;
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$d0dc094613469f2b extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.workspaceId = void 0;
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5603eab37ce562f5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.fileType = void 0;
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e0e9aa0e9c6b37ff extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.error = void 0;
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3ad818f64601e141 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$25470bb6cba4fba0 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.messageTemplateId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ce14d445679448b6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.messageTemplateId = void 0;
        this.messageInstanceId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $0a8f0e83dcf5160a$export$c9a26a17db1045c8 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8ab4fb362168b928 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2afd69f57fe5285f extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$7635d2b1a281d626 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = void 0;
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$9e1c6d00e675bc86 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.recipient = void 0;
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$6d1a4929f6ff1a32 extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = void 0;
        this.messageInstanceId = void 0;
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$c504492f06c975b5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.ipmNumber = void 0;
        this.variantFromStatsig = void 0;
        this.contentfulLocale = void 0;
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1c932b9d1680ee0b extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5d5d1885c87ef4bc extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
module.exports["PostOfficeErrorCodes"] = $0a8f0e83dcf5160a$export$b9722560029694e7;
module.exports["PostOfficeError"] = $0a8f0e83dcf5160a$export$d145ea5319863172;
module.exports["InvalidMessageTemplateIdError"] = $0a8f0e83dcf5160a$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d;

});

parcelRegister("h6POP", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");

const $7e9b04f8bb48d01d$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: (0, $fwDOR.default),
    UFOSegment: (0, $hnvzE.default)
};
module.exports["UFOv2"] = $7e9b04f8bb48d01d$export$c91b09caa8ecbab1;

});

parcelRegister("4oTqF", function(module, exports) {
/**
 * Canonical message context implementation.
 *
 * This is the source of truth. `@post-office/message-context` re-exports from here.
 * Consumers should import via:
 *   import { useMessageContext, MessageContextProvider } from '@atlassian/post-office-context/message-context';
 */ 
var $42omo = parcelRequire("42omo");

const $00b958a3f78a4846$var$initialValue = {};
const $00b958a3f78a4846$export$b060d577040138d8 = (0, $42omo.createContext)($00b958a3f78a4846$var$initialValue);
const $00b958a3f78a4846$export$42de33f7652dc3de = $00b958a3f78a4846$export$b060d577040138d8.Provider;
const $00b958a3f78a4846$export$a5b6d14a2e25725a = ()=>(0, $42omo.useContext)($00b958a3f78a4846$export$b060d577040138d8);
module.exports["MessageContextProvider"] = $00b958a3f78a4846$export$42de33f7652dc3de;
module.exports["useMessageContext"] = $00b958a3f78a4846$export$a5b6d14a2e25725a;

});

parcelRegister("5pgAV", function(module, exports) {
/**
 * Canonical recommendation context implementation.
 *
 * This is the source of truth. `@post-office/recommendation-context` re-exports from here.
 */ 
var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $66ed3195d851a905$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $42omo.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $66ed3195d851a905$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($66ed3195d851a905$export$ba2f44035effd9c1.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: value
    }, children));
};
const $66ed3195d851a905$export$3321c0b02f750bcc = ()=>(0, $42omo.useContext)($66ed3195d851a905$export$ba2f44035effd9c1);
module.exports["RecommendationProvider"] = $66ed3195d851a905$export$f60e87d7b5f59562;
module.exports["useRecommendationContext"] = $66ed3195d851a905$export$3321c0b02f750bcc;

});

parcelRegister("eNels", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $45587d2f47667e39$export$d5a462ce7bd04520 = async (messageTemplateId, placementId, _locale)=>{
    const candidate = `@post-office/i18n-translation/${messageTemplateId}-in-app/${placementId}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return await import(/* webpackIgnore: true */ candidate);
};
function $45587d2f47667e39$export$c003690f5ce066ed(messageTemplateId, placementId, messageLoader = $45587d2f47667e39$export$d5a462ce7bd04520) {
    const [messages, setMessages] = (0, $42omo.useState)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    let locale = 'en';
    try {
        locale = (0, $aXWIB.useIntl)().locale;
    } catch  {
    // fallback to en
    }
    (0, $42omo.useEffect)(()=>{
        messageLoader(messageTemplateId, placementId, locale).then((loadedMessages)=>{
            setMessages(loadedMessages.default);
        }).catch(()=>{
            setMessages({});
            fireAnalyticsEvent({
                action: 'error',
                actionSubject: 'i18nMessageLoader',
                eventType: 'operational'
            });
        });
    }, [
        fireAnalyticsEvent,
        locale,
        messageLoader,
        messageTemplateId,
        placementId
    ]);
    return {
        locale: locale,
        messages: messages
    };
}
const $45587d2f47667e39$var$I18nProvider = ({ children: children, messageTemplateId: messageTemplateId, placementId: placementId, messageLoader: messageLoader })=>{
    const { locale: locale, messages: messages } = $45587d2f47667e39$export$c003690f5ce066ed(messageTemplateId, placementId, messageLoader);
    if (!messages || Object.keys(messages).length === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        children: children
    });
};
const $45587d2f47667e39$export$d55fcc9e7bd9ff3e = ({ isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled, messageTemplateId: messageTemplateId, placementId: placementId, children: children, messageLoader: messageLoader = $45587d2f47667e39$export$d5a462ce7bd04520 })=>{
    if (!isI18nMigrationInAppEnabled || !placementId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($45587d2f47667e39$var$I18nProvider, {
        messageTemplateId: messageTemplateId,
        placementId: placementId,
        messageLoader: messageLoader,
        children: children
    });
};
module.exports["MaybeI18nProvider"] = $45587d2f47667e39$export$d55fcc9e7bd9ff3e;

});

parcelRegister("7XIdu", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $42omo = parcelRequire("42omo");

const $ddf71c7c19f3c4df$export$85183a312807388d = 'postOffice';
const $ddf71c7c19f3c4df$export$33911828b25deac7 = 'engagementPlatform';
const $ddf71c7c19f3c4df$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $ddf71c7c19f3c4df$export$f7fadc54a04f9307 = {
    eventType: 'track',
    action: 'exposed',
    actionSubject: 'feature',
    source: 'engagement-platform',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ]
};
const $ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992 = {
    eventType: 'operational',
    action: 'stopped',
    actionSubject: 'message',
    source: 'epTargeting',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ],
    product: 'engagementPlatform'
};
const $ddf71c7c19f3c4df$export$f14470c9a12428fc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        if (eventPayload.messageType === 'inapp') {
            const epMessageId = `engagement.inproduct.${eventPayload.messageId}`;
            createAnalyticsEvent({
                ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307,
                ...eventPayload,
                actionSubjectId: epMessageId,
                attributes: {
                    ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307.attributes,
                    ...eventPayload.locale && {
                        locale: eventPayload.locale
                    },
                    ...attributes,
                    flagKey: epMessageId
                }
            }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
        } else createAnalyticsEvent({
            ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992,
            ...eventPayload,
            actionSubjectId: eventPayload.messageId,
            attributes: {
                ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992.attributes,
                ...eventPayload.locale && {
                    locale: eventPayload.locale
                },
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
module.exports["useFirePostOfficeAnalyticsEvents"] = $ddf71c7c19f3c4df$export$57d19d18d6e255a5;
module.exports["useFireEngagementPlatformAnalyticsEvents"] = $ddf71c7c19f3c4df$export$f14470c9a12428fc;

});

parcelRegister("5RZ3F", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $iX6G3 = parcelRequire("iX6G3");

const $92519f251282f573$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $92519f251282f573$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $iX6G3.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($92519f251282f573$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $92519f251282f573$export$8db7ba034addcd65;

});

parcelRegister("iX6G3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $PAiZW = parcelRequire("PAiZW");

var $c3xd8 = parcelRequire("c3xd8");

/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components.
 *
 * NOTE: This is a copy of
 * `post-office/packages/util/shared-contracts/src/util/in-browser-debug-logger.ts`
 * to avoid a cross-workspace import. You may want to keep them in sync.
 *
 * Usage:
 * - Enable:  window.postOffice{Component}Debug = true
 * - Disable: window.postOffice{Component}Debug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $3b287a706604981d$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};


// @twood: NEVER CHANGE THIS DEFAULT VALUE
const $336186ad37416db8$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $336186ad37416db8$var$choreographerLogger = (0, $3b287a706604981d$export$806eda59584e395d)('Choreographer');
const $336186ad37416db8$var$defaultContext = {
    choreographerEnabled: $336186ad37416db8$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $336186ad37416db8$var$ChoreographerContext = /*#__PURE__*/ (0, $42omo.createContext)($336186ad37416db8$var$defaultContext);
// Helper to automatically handle ESM and non-ESM imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $336186ad37416db8$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        $336186ad37416db8$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        $336186ad37416db8$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        $336186ad37416db8$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $336186ad37416db8$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};

const $336186ad37416db8$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $42omo.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $42omo.useState)(choreographer?.isDefaultEnabled ?? $336186ad37416db8$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $c3xd8.usePostOfficeEnvironment)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    (0, $42omo.useEffect)(()=>{
        if (choreographerEnabled) // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("8N5Gi")).then((m)=>{
            const ChoreographerRegistryClass = $336186ad37416db8$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $336186ad37416db8$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $336186ad37416db8$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $336186ad37416db8$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $336186ad37416db8$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $42omo.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        $336186ad37416db8$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($336186ad37416db8$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext
    }, children);
};
const $336186ad37416db8$export$cab5a8adbabcee23 = ()=>(0, $42omo.useContext)($336186ad37416db8$var$ChoreographerContext);
module.exports["StableChoreographerProvider"] = $336186ad37416db8$export$e68b2c75bfb5682a;
module.exports["useChoreographerContext"] = $336186ad37416db8$export$cab5a8adbabcee23;

});

parcelRegister("8N5Gi", function(module, exports) {

let $01a6d3d8dbb1e45b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01a6d3d8dbb1e45b$var$load("jkyW3").then(()=>parcelRequire('8Dkwu'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("2amyA", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $h6POP = parcelRequire("h6POP");

const $5a78db0628042bee$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $5a78db0628042bee$export$8e6fb7035018b3e4;

});

parcelRegister("Sjnjb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $crDNP = parcelRequire("crDNP");

/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $54a73c30ae097a04$var$HIDDEN_CONTAINER_STYLE = {
    display: 'none'
};
const $54a73c30ae097a04$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $42omo.useState)('pending');
    const isFirstEffectRun = (0, $42omo.useRef)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            isFirstEffectRun.current = false;
            setValidated('allowed');
            return;
        }
        // First run: template may not have run yet (e.g. lazy component suspended). Stay pending
        // so we re-check when children update (after Suspense resolves and template runs).
        if (isFirstEffectRun.current) {
            isFirstEffectRun.current = false;
            return;
        }
        // Ref not set after template had a chance to run (e.g. second commit or template didn't call)
        if (calledRef) setValidated('blocked');
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === 'blocked') return null;
    const isHidden = validated === 'pending';
    if ((0, $c6GJD.default).checkGate('post-office_enable_fixed-viewed-handling')) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: isHidden ? $54a73c30ae097a04$var$HIDDEN_CONTAINER_STYLE : undefined,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $crDNP.ManualMessageViewedEvent), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: isHidden ? $54a73c30ae097a04$var$HIDDEN_CONTAINER_STYLE : undefined,
            "aria-hidden": isHidden,
            "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
            children: children
        })
    });
};
module.exports["TriggeredMessageValidator"] = $54a73c30ae097a04$export$c8b5f992b8a1b38b;

});

parcelRegister("crDNP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $gVWoV = parcelRequire("gVWoV");


var $jVJ5P = parcelRequire("jVJ5P");


var $42omo = parcelRequire("42omo");

var $a4738caf79f2dd10$export$1e511d4a378977f5;
var $a4738caf79f2dd10$export$6215040b989f9b0f;
var $a4738caf79f2dd10$export$436b63fa4855237f;
var $a4738caf79f2dd10$export$2e2bcd8739ae039;
var $a4738caf79f2dd10$export$95cef81be5ddcfd4;
"use strict";
$a4738caf79f2dd10$export$1e511d4a378977f5 = true;
$a4738caf79f2dd10$export$6215040b989f9b0f = $a4738caf79f2dd10$export$436b63fa4855237f = $a4738caf79f2dd10$export$2e2bcd8739ae039 = $a4738caf79f2dd10$export$95cef81be5ddcfd4 = void 0;

var $a4738caf79f2dd10$var$_handleViewport = $a4738caf79f2dd10$var$_interopRequireDefault((parcelRequire("cQglR")));
$a4738caf79f2dd10$export$436b63fa4855237f = $a4738caf79f2dd10$var$_handleViewport.default;

var $a4738caf79f2dd10$var$_useInViewport = $a4738caf79f2dd10$var$_interopRequireDefault((parcelRequire("fvKTt")));
$a4738caf79f2dd10$export$6215040b989f9b0f = $a4738caf79f2dd10$var$_useInViewport.default;
function $a4738caf79f2dd10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $a4738caf79f2dd10$var$customProps = $a4738caf79f2dd10$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $a4738caf79f2dd10$var$_default = $a4738caf79f2dd10$export$2e2bcd8739ae039 = $a4738caf79f2dd10$var$_handleViewport.default;



var $aEUWC = parcelRequire("aEUWC");


var $fUB5z = parcelRequire("fUB5z");

const $b9b497d1215dcd3f$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $aEUWC.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
const $b9b497d1215dcd3f$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $aEUWC.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $gVWoV.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $42omo.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $42omo.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $42omo.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $b9b497d1215dcd3f$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $42omo.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $gVWoV.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $a4738caf79f2dd10$export$6215040b989f9b0f)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $42omo.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $42omo.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $l998X.jsx)($b9b497d1215dcd3f$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
module.exports["ManualMessageViewedEvent"] = $b9b497d1215dcd3f$export$de534803cb07dfcc;
module.exports["MessageViewed"] = $b9b497d1215dcd3f$export$14fe1fc3395b6e3f;

});

parcelRegister("gVWoV", function(module, exports) {

var $PAiZW = parcelRequire("PAiZW");


var $4oTqF = parcelRequire("4oTqF");


var $GHZ06 = parcelRequire("GHZ06");

parcelRequire("aCX5O");
var $5pgAV = parcelRequire("5pgAV");


var $42omo = parcelRequire("42omo");

class $cf44d591220b1074$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $cf44d591220b1074$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}


const $49d0938c9296dd55$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("1IQCv"));
class $49d0938c9296dd55$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $49d0938c9296dd55$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}


const $736ffbfc26ebdab1$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $49d0938c9296dd55$export$4564cfc2de39be55)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null, configSetId: configSetId } = (0, $4oTqF.useMessageContext)();
    const { placementId: placementId } = (0, $GHZ06.usePlacementContext)();
    const browserContext = (0, $PAiZW.usePostOfficeContext)();
    const recommendationContext = (0, $5pgAV.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $42omo.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $cf44d591220b1074$export$9ffc53d3edc152da)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceViewed = (0, $42omo.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $cf44d591220b1074$export$9ffc53d3edc152da)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceClicked = (0, $42omo.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId && !params.messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $cf44d591220b1074$export$9ffc53d3edc152da)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};
module.exports["useMessageInstanceEvent"] = $736ffbfc26ebdab1$export$39b0f5626e96f41e;

});

parcelRegister("1IQCv", function(module, exports) {
$parcel$export(module.exports, "DOMException", () => $1412b7bab5fe955c$export$fe58bcf938607f6a);
/* eslint-disable no-prototype-builtins */ var $1412b7bab5fe955c$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $1412b7bab5fe955c$var$support = {
    searchParams: 'URLSearchParams' in $1412b7bab5fe955c$var$g,
    iterable: 'Symbol' in $1412b7bab5fe955c$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $1412b7bab5fe955c$var$g && 'Blob' in $1412b7bab5fe955c$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $1412b7bab5fe955c$var$g,
    arrayBuffer: 'ArrayBuffer' in $1412b7bab5fe955c$var$g
};
function $1412b7bab5fe955c$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($1412b7bab5fe955c$var$support.arrayBuffer) {
    var $1412b7bab5fe955c$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $1412b7bab5fe955c$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $1412b7bab5fe955c$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $1412b7bab5fe955c$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $1412b7bab5fe955c$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $1412b7bab5fe955c$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($1412b7bab5fe955c$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $1412b7bab5fe955c$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $1412b7bab5fe955c$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $1412b7bab5fe955c$var$normalizeName(name);
    value = $1412b7bab5fe955c$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$1412b7bab5fe955c$var$normalizeName(name)];
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $1412b7bab5fe955c$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($1412b7bab5fe955c$var$normalizeName(name));
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$1412b7bab5fe955c$var$normalizeName(name)] = $1412b7bab5fe955c$var$normalizeValue(value);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $1412b7bab5fe955c$var$iteratorFor(items);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $1412b7bab5fe955c$var$iteratorFor(items);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $1412b7bab5fe955c$var$iteratorFor(items);
};
if ($1412b7bab5fe955c$var$support.iterable) $1412b7bab5fe955c$export$79b704688b15c0f4.prototype[Symbol.iterator] = $1412b7bab5fe955c$export$79b704688b15c0f4.prototype.entries;
function $1412b7bab5fe955c$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $1412b7bab5fe955c$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $1412b7bab5fe955c$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $1412b7bab5fe955c$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $1412b7bab5fe955c$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $1412b7bab5fe955c$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $1412b7bab5fe955c$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $1412b7bab5fe955c$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $1412b7bab5fe955c$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($1412b7bab5fe955c$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($1412b7bab5fe955c$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($1412b7bab5fe955c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($1412b7bab5fe955c$var$support.arrayBuffer && $1412b7bab5fe955c$var$support.blob && $1412b7bab5fe955c$var$isDataView(body)) {
            this._bodyArrayBuffer = $1412b7bab5fe955c$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($1412b7bab5fe955c$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $1412b7bab5fe955c$var$isArrayBufferView(body))) this._bodyArrayBuffer = $1412b7bab5fe955c$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($1412b7bab5fe955c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($1412b7bab5fe955c$var$support.blob) this.blob = function() {
        var rejected = $1412b7bab5fe955c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $1412b7bab5fe955c$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($1412b7bab5fe955c$var$support.blob) return this.blob().then($1412b7bab5fe955c$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $1412b7bab5fe955c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $1412b7bab5fe955c$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($1412b7bab5fe955c$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($1412b7bab5fe955c$var$support.formData) this.formData = function() {
        return this.text().then($1412b7bab5fe955c$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $1412b7bab5fe955c$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $1412b7bab5fe955c$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $1412b7bab5fe955c$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $1412b7bab5fe955c$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $1412b7bab5fe955c$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $1412b7bab5fe955c$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $1412b7bab5fe955c$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $1412b7bab5fe955c$export$79b704688b15c0f4(options.headers);
    this.method = $1412b7bab5fe955c$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $1412b7bab5fe955c$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$1412b7bab5fe955c$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $1412b7bab5fe955c$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $1412b7bab5fe955c$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $1412b7bab5fe955c$var$parseHeaders(rawHeaders) {
    var headers = new $1412b7bab5fe955c$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$1412b7bab5fe955c$var$Body.call($1412b7bab5fe955c$export$7fa6c5b6f8193917.prototype);
function $1412b7bab5fe955c$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $1412b7bab5fe955c$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $1412b7bab5fe955c$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$1412b7bab5fe955c$var$Body.call($1412b7bab5fe955c$export$9f633d56d7ec90d3.prototype);
$1412b7bab5fe955c$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $1412b7bab5fe955c$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $1412b7bab5fe955c$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$1412b7bab5fe955c$export$9f633d56d7ec90d3.error = function() {
    var response = new $1412b7bab5fe955c$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $1412b7bab5fe955c$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$1412b7bab5fe955c$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($1412b7bab5fe955c$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $1412b7bab5fe955c$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $1412b7bab5fe955c$export$fe58bcf938607f6a = $1412b7bab5fe955c$var$g.DOMException;
try {
    new $1412b7bab5fe955c$export$fe58bcf938607f6a();
} catch (err) {
    $1412b7bab5fe955c$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $1412b7bab5fe955c$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $1412b7bab5fe955c$export$fe58bcf938607f6a.prototype.constructor = $1412b7bab5fe955c$export$fe58bcf938607f6a;
}
function $1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $1412b7bab5fe955c$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $1412b7bab5fe955c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $1412b7bab5fe955c$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $1412b7bab5fe955c$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $1412b7bab5fe955c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $1412b7bab5fe955c$var$g.location.href ? $1412b7bab5fe955c$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($1412b7bab5fe955c$var$support.blob) xhr.responseType = 'blob';
            else if ($1412b7bab5fe955c$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $1412b7bab5fe955c$export$79b704688b15c0f4 || $1412b7bab5fe955c$var$g.Headers && init.headers instanceof $1412b7bab5fe955c$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($1412b7bab5fe955c$var$normalizeName(name));
                xhr.setRequestHeader(name, $1412b7bab5fe955c$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$1412b7bab5fe955c$var$g.fetch) {
    $1412b7bab5fe955c$var$g.fetch = $1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3;
    $1412b7bab5fe955c$var$g.Headers = $1412b7bab5fe955c$export$79b704688b15c0f4;
    $1412b7bab5fe955c$var$g.Request = $1412b7bab5fe955c$export$7fa6c5b6f8193917;
    $1412b7bab5fe955c$var$g.Response = $1412b7bab5fe955c$export$9f633d56d7ec90d3;
}
module.exports["Headers"] = $1412b7bab5fe955c$export$79b704688b15c0f4;
module.exports["Request"] = $1412b7bab5fe955c$export$7fa6c5b6f8193917;
module.exports["Response"] = $1412b7bab5fe955c$export$9f633d56d7ec90d3;
module.exports["fetch"] = $1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("jVJ5P", function(module, exports) {

var $cpPWT = parcelRequire("cpPWT");

var $PAiZW = parcelRequire("PAiZW");


var $4oTqF = parcelRequire("4oTqF");


var $GHZ06 = parcelRequire("GHZ06");

parcelRequire("aCX5O");
var $5pgAV = parcelRequire("5pgAV");


var $42omo = parcelRequire("42omo");

class $60ff315a8e8596ab$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $60ff315a8e8596ab$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}




/**
 * Re-exports from the canonical implementation in `@atlassian/post-office-context`.
 *
 * The source of truth is:
 *   platform/packages/post-office/post-office-context/src/message-lifecycle/message-event-client.ts
 *
 * This re-export ensures that `@post-office/message-lifecycle` and
 * `@atlassian/post-office-context` share the same `MessageEventClient` class
 * identity, avoiding TypeScript structural mismatch errors caused by private fields.
 */ 
var $ei5m0 = parcelRequire("ei5m0");



var $bdfc318f2434f78e$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});


const $30a6ba7a29ef3ba2$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $ei5m0.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $cpPWT.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $4oTqF.useMessageContext)();
    const { placementId: placementId } = (0, $GHZ06.usePlacementContext)();
    const browserContext = (0, $PAiZW.usePostOfficeContext)();
    const recommendationContext = (0, $5pgAV.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $42omo.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $60ff315a8e8596ab$export$44f397e2afeb89e0)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $60ff315a8e8596ab$export$44f397e2afeb89e0)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $60ff315a8e8596ab$export$44f397e2afeb89e0)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $42omo.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ff315a8e8596ab$export$12bb62b204112f55)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $bdfc318f2434f78e$export$b31ffc6f7c85f1b).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};
module.exports["useMessageEvent"] = $30a6ba7a29ef3ba2$export$3cbbf1e81e2ecb39;

});

parcelRegister("cQglR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $959706786c414c90$export$1e511d4a378977f5, (v) => $959706786c414c90$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $959706786c414c90$export$2e2bcd8739ae039, (v) => $959706786c414c90$export$2e2bcd8739ae039 = v);
var $959706786c414c90$export$1e511d4a378977f5;
var $959706786c414c90$export$2e2bcd8739ae039;
"use strict";
$959706786c414c90$export$1e511d4a378977f5 = true;
$959706786c414c90$export$2e2bcd8739ae039 = void 0;

var $42omo = parcelRequire("42omo");


var $959706786c414c90$var$_hoistNonReactStatics = $959706786c414c90$var$_interopRequireDefault((parcelRequire("56GFp")));

var $959706786c414c90$var$_useInViewport = $959706786c414c90$var$_interopRequireDefault((parcelRequire("fvKTt")));

var $jC1t2 = parcelRequire("jC1t2");


var $l998X = parcelRequire("l998X");

var $959706786c414c90$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $959706786c414c90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $959706786c414c90$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $959706786c414c90$var$_extends() {
    return $959706786c414c90$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $959706786c414c90$var$_extends.apply(null, arguments);
}
function $959706786c414c90$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $jC1t2.defaultOptions;
    if (config === void 0) config = $jC1t2.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $l998X.jsx)(TargetComponent, $959706786c414c90$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $jC1t2.noop, onLeaveViewport: onLeaveViewport = $jC1t2.noop } = _ref, restProps = $959706786c414c90$var$_objectWithoutPropertiesLoose(_ref, $959706786c414c90$var$_excluded);
        var node = (0, $42omo.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $959706786c414c90$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $959706786c414c90$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $l998X.jsx)(ForwardedRefComponent, $959706786c414c90$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $959706786c414c90$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $959706786c414c90$var$_default = $959706786c414c90$export$2e2bcd8739ae039 = $959706786c414c90$var$handleViewport;

});

parcelRegister("fvKTt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $02ea08c7e210a161$export$1e511d4a378977f5, (v) => $02ea08c7e210a161$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $02ea08c7e210a161$export$2e2bcd8739ae039, (v) => $02ea08c7e210a161$export$2e2bcd8739ae039 = v);
var $02ea08c7e210a161$export$1e511d4a378977f5;
var $02ea08c7e210a161$export$2e2bcd8739ae039;
"use strict";
$02ea08c7e210a161$export$1e511d4a378977f5 = true;
$02ea08c7e210a161$export$2e2bcd8739ae039 = void 0;

var $42omo = parcelRequire("42omo");


var $jC1t2 = parcelRequire("jC1t2");

var $02ea08c7e210a161$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $02ea08c7e210a161$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $jC1t2.defaultOptions;
    if (config === void 0) config = $jC1t2.defaultConfig;
    if (props === void 0) props = $jC1t2.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $42omo.useState)();
    var observer = (0, $42omo.useRef)();
    var inViewportRef = (0, $42omo.useRef)(false);
    var intersected = (0, $42omo.useRef)(false);
    var enterCountRef = (0, $42omo.useRef)(0);
    var leaveCountRef = (0, $42omo.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $42omo.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $42omo.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $42omo.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $02ea08c7e210a161$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $02ea08c7e210a161$var$_default = $02ea08c7e210a161$export$2e2bcd8739ae039 = $02ea08c7e210a161$var$useInViewport;

});

parcelRegister("aEUWC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $03b25510c5956e6e$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $03b25510c5956e6e$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $42omo.createContext)($03b25510c5956e6e$var$defaultMessageAnalyticsContextValue);
const $03b25510c5956e6e$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $42omo.useRef)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($03b25510c5956e6e$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $03b25510c5956e6e$export$bb426ba114b64992 = ()=>(0, $42omo.useContext)($03b25510c5956e6e$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $03b25510c5956e6e$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $03b25510c5956e6e$export$bb426ba114b64992;

});

parcelRegister("fUB5z", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $28f53716d0e10e9b$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $28f53716d0e10e9b$export$21b400a8c8ebc91a;

});

parcelRegister("4S89c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $crDNP = parcelRequire("crDNP");

const $b30ccc91f26ed8ac$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    if ((0, $c6GJD.default).checkGate('post-office_enable_fixed-viewed-handling')) return isManual ? /*#__PURE__*/ (0, $l998X.jsx)((0, $crDNP.ManualMessageViewedEvent), {
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["MaybeManualMessageViewedEvent"] = $b30ccc91f26ed8ac$export$9915b88f81e90e6e;

});

parcelRegister("kODQd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $4fa55b3f6245b5e9$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscription: undefined
});
const $4fa55b3f6245b5e9$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($4fa55b3f6245b5e9$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $4fa55b3f6245b5e9$export$1129f1fe63b2d7ab = ()=>{
    return (0, $42omo.useContext)($4fa55b3f6245b5e9$var$SubscriptionConfigContext);
};
module.exports["StableSubscriptionConfigProvider"] = $4fa55b3f6245b5e9$export$d870bd1cf2974c88;
module.exports["useSubscriptionConfig"] = $4fa55b3f6245b5e9$export$1129f1fe63b2d7ab;

});

parcelRegister("9iUWG", function(module, exports) {
const $eceb70624fd909b9$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
module.exports["isClientTriggeredMessage"] = $eceb70624fd909b9$export$21c420c0c257c346;

});

parcelRegister("eXPKf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $h6POP = parcelRequire("h6POP");


var $42omo = parcelRequire("42omo");


var $fUB5z = parcelRequire("fUB5z");




const $6d839c5f036ae335$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    // Initialise to true only if there's a Promise to await, avoiding an unnecessary UFO hold on mount.
    const [isLoading, setIsLoading] = (0, $42omo.useState)(initialData !== undefined);
    const onMount = (0, $42omo.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $42omo.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};


const $3a8bbfb177ab8743$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $6d839c5f036ae335$export$317d52099614f316)(props);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                name: (0, $h6POP.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $3a8bbfb177ab8743$export$b35129264a401b3c = /*#__PURE__*/ (0, $42omo.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $c6GJD.default).checkGate('post_office_update_ufov2_placements');
    /**
   * If feature gate is not enabled, then we just return the children without the
   * UFO segments attached.
   */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $3a8bbfb177ab8743$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $3a8bbfb177ab8743$export$b35129264a401b3c;

});

parcelRegister("MnX4h", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");





var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $kODQd = parcelRequire("kODQd");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $5ba220ca4e76952d$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const subscriptionConfig = (0, $kODQd.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    (0, $42omo.useEffect)(()=>{
        if ($5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement',
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};






var $ffCOo = parcelRequire("ffCOo");

const $6622e517a1cb034d$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "5c4a61331923a52a2f6b1f5f20989dec79f5060b",
            b: "14484974",
            t: undefined
        }
    }
};
const $6622e517a1cb034d$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: $6622e517a1cb034d$var$postOfficeAnalyticsContextData,
        children: children
    });
};



var $iX6G3 = parcelRequire("iX6G3");





var $PAiZW = parcelRequire("PAiZW");

var $4H1Ql = parcelRequire("4H1Ql");


var $a8wvv = parcelRequire("a8wvv");

const $d8708472710e950a$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $4H1Ql.useStableObject)({
        ...(0, $a8wvv.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $PAiZW.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};









var $GHZ06 = parcelRequire("GHZ06");

const $2119b7887220da1c$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $4H1Ql.useStableObject)(placement);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $GHZ06.PlacementProvider), {
        value: stableValue,
        children: children
    });
};









var $6yHRM = parcelRequire("6yHRM");



const $b036fb6e61b1c432$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $b036fb6e61b1c432$export$49fc3f3d8c7f99 = ()=>{
    return $b036fb6e61b1c432$var$isLocationAvailable() ? globalThis.location.href : undefined;
};


const $ee97961d0a968e6e$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $b036fb6e61b1c432$export$49fc3f3d8c7f99)();
    const stableRoute = (0, $4H1Ql.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6yHRM.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};



var $eXPKf = parcelRequire("eXPKf");

/**
 * Feature gate name for GraphQL subscriptions in Post Office placements.
 * When disabled, subscriptions will not be enabled even if configured.
 */ // https://switcheroo.atlassian.com/ui/gates/8299833f-7cf4-453b-bd5b-16f3bcf81ddb/key/post-office_graphql_subscriptions_enabled
const $e96f8aedef8f7ae2$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = 'post-office_graphql_subscriptions_enabled';
/**
 * Optional provider that wraps subscription providers only if feature gate is enabled.
 */ const $e96f8aedef8f7ae2$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children, subscription: subscription })=>{
    const isPostOfficeSubscriptionsFeatureGateEnabled = (0, $c6GJD.default).checkGate($e96f8aedef8f7ae2$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE);
    if (isPostOfficeSubscriptionsFeatureGateEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kODQd.StableSubscriptionConfigProvider), {
        subscription: subscription,
        children: children
    });
    return children;
};
const $e96f8aedef8f7ae2$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8708472710e950a$export$d4982c0a28b18f63), {
        context: context,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2119b7887220da1c$export$e9fd288527498af6), {
            placement: placement,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ee97961d0a968e6e$export$ce13d00e696dfc96), {
                route: route,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6622e517a1cb034d$export$5a66cdc9893b43e), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)($e96f8aedef8f7ae2$var$OptionalPostOfficeSubscriptionsProvider, {
                        subscription: subscription,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iX6G3.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ba220ca4e76952d$export$2d84fd9af6c9e378), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
module.exports["StableProviders"] = $e96f8aedef8f7ae2$export$2b6596bcb1383a71;

});

parcelRegister("a8wvv", function(module, exports) {
const $f5ba185a6bfa7119$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $f5ba185a6bfa7119$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $f5ba185a6bfa7119$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $f5ba185a6bfa7119$export$71ff7382870ef1b0;

});

parcelRegister("2HRxT", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7TH2w = parcelRequire("7TH2w");


var $7XIdu = parcelRequire("7XIdu");


var $lAJUP = parcelRequire("lAJUP");

const $efad4e1316fb199e$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $l998X.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withErrorBoundary"] = $efad4e1316fb199e$export$f0c7a449e0cfaec7;

});

parcelRegister("cqOSB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5RZ3F = parcelRequire("5RZ3F");


var $gVWoV = parcelRequire("gVWoV");

/**
 * Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
 */ const $3151eb9717652767$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $42omo.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!hasShownRef.current) {
            hasShownRef.current = true;
            messageInstanceViewed({
                ...additionalMetadataFromFrontend
            });
            onShow?.();
        }
    }, [
        onShow,
        messageInstanceViewed,
        additionalMetadataFromFrontend
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
const $3151eb9717652767$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const waitForTriggerCalledRef = (0, $42omo.useRef)(false);
    // Create waitForTrigger function that wraps content with choreography
    const waitForTriggerCallback = (0, $42omo.useCallback)((isTriggerActive, messageContent, onShow, additionalMetadataFromFrontend)=>{
        // Mark that this function was called
        waitForTriggerCalledRef.current = true;
        // If isTriggerActive is false, don't claim choreographer slot yet
        if (!isTriggerActive) return null;
        // When triggered, wrap content with choreography and analytics
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5RZ3F.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            children: /*#__PURE__*/ (0, $l998X.jsx)($3151eb9717652767$var$OnChoreographerApproved, {
                onShow: onShow,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: messageContent
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : undefined; // Non-triggered messages don't get this prop
    // Attach the ref to the function as a property
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};
module.exports["useWaitForTrigger"] = $3151eb9717652767$export$b5884e72fa051e28;

});

parcelRegister("j0Fou", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $PAiZW = parcelRequire("PAiZW");


var $kO3gu = parcelRequire("kO3gu");


var $GHZ06 = parcelRequire("GHZ06");

const $c9d2f99792ae105c$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $c9d2f99792ae105c$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $c9d2f99792ae105c$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$c9d2f99792ae105c$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $c9d2f99792ae105c$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($c9d2f99792ae105c$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$c9d2f99792ae105c$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};



var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $872a969cc90d2799$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $42omo.useRef)();
        const isRunningPromise = (0, $42omo.useRef)(false);
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $42omo.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $gAOec.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $c9d2f99792ae105c$export$ce743d02f83ee521)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $gAOec.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};



var $fCcUZ = parcelRequire("fCcUZ");

const $785c8761b65409e5$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $785c8761b65409e5$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $785c8761b65409e5$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$785c8761b65409e5$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $785c8761b65409e5$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $785c8761b65409e5$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($785c8761b65409e5$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$785c8761b65409e5$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $fCcUZ.default)(placementId ? url : null, (url)=>fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$785c8761b65409e5$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};



var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");

const $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $785c8761b65409e5$export$ef70136078f15deb)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};



var $kODQd = parcelRequire("kODQd");




// https://switcheroo.atlassian.com/ui/gates/746a161c-d307-4db3-a966-8fe63c551fea/key/post-office_skip_rest_for_graphql_subscription
const $68a42afbf7553230$var$SKIP_REST_FETCH_GATE = 'post-office_skip_rest_for_graphql_subscription';
const $68a42afbf7553230$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $GHZ06.usePlacementContext)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const { subscription: subscription } = (0, $kODQd.useSubscriptionConfig)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found. Ensure this hook is used as a child of PlacementProvider.')
            });
        // Prefer the explicit prop when provided; fall back to the Switcheroo gate
        // so existing callers that have not yet migrated continue to work unchanged.
        const isClientFetch = config?.useClientFetch !== undefined ? config.useClientFetch : (0, $c6GJD.default).checkGate('post-office-use-placement-with-client');
        if (isClientFetch) return (0, $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1)(placementId, fetcher);
        return (0, $872a969cc90d2799$export$ee1d67e435d25cb5)(placementId, fetcher);
    }, [
        placementId,
        fetcher,
        config?.useClientFetch
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    const apiDependencies = (0, $42omo.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    // disable REST fetch for initialMessages for subscription based placements if the gate is enabled
    const isSubscriptionBasedFetchDisabled = subscription?.enabled === true && (0, $c6GJD.default).checkGate($68a42afbf7553230$var$SKIP_REST_FETCH_GATE);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: isSubscriptionBasedFetchDisabled ? false : config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};
module.exports["usePlacementApi"] = $68a42afbf7553230$export$201bbce8187a6e3c;

});

parcelRegister("gAOec", function(module, exports) {

var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");


var $42omo = parcelRequire("42omo");

const $7d79f12ff0021e5f$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $7d79f12ff0021e5f$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($7d79f12ff0021e5f$export$18a0019e5439b209(res));
};
const $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $7d79f12ff0021e5f$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $7d79f12ff0021e5f$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });


class $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $42omo.useState)((0, $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $42omo.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $7d79f12ff0021e5f$export$b3732c8ff6f9c463)(res)) {
                const data = await res.json();
                setState((0, $7d79f12ff0021e5f$export$24a6b176bdc41ce5)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $7d79f12ff0021e5f$export$cc3b967c039ed3e7)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b;
module.exports["useData"] = $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937;

});

parcelRegister("5pS3b", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $aXWIB = parcelRequire("aXWIB");





var $42omo = parcelRequire("42omo");

const $9f428f426036dbfa$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $42omo.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};


function $b2d267b4c02f41c6$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $aXWIB.useIntl)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $b2d267b4c02f41c6$export$480518999dfc4151(props) {
    const { locale: locale } = $b2d267b4c02f41c6$var$useFetchLocale();
    const messages = (0, $9f428f426036dbfa$export$2641ec9a2025a81f)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}
module.exports["IntlProvider"] = $b2d267b4c02f41c6$export$480518999dfc4151;

});

parcelRegister("jQRRW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $5pS3b = parcelRequire("5pS3b");

const $221a2b03be5b44a4$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5pS3b.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withIntlProvider"] = $221a2b03be5b44a4$export$a5d940130f33be3f;

});

parcelRegister("GHZ06", function(module, exports) {
/**
 * Canonical placement context implementation.
 *
 * This is the source of truth. `@post-office/placement-context` re-exports from here.
 * Consumers should import via:
 *   import { PlacementProvider, usePlacementContext } from '@atlassian/post-office-context/placement-context';
 */ 
var $42omo = parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");


var $3Bn1T = parcelRequire("3Bn1T");

const $3644d4818c793a3e$export$6394bf86db095a8 = /*#__PURE__*/ (0, $42omo.createContext)({
    placementId: undefined
});
const $3644d4818c793a3e$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $3Bn1T.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3644d4818c793a3e$export$6394bf86db095a8.Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: memoizedValue
    }, children));
};
const $3644d4818c793a3e$export$4fc0446ee742ad80 = ()=>(0, $42omo.useContext)($3644d4818c793a3e$export$6394bf86db095a8);
module.exports["PlacementProvider"] = $3644d4818c793a3e$export$6272e220478c7f1d;
module.exports["usePlacementContext"] = $3644d4818c793a3e$export$4fc0446ee742ad80;

});

parcelRegister("ei5m0", function(module, exports) {
/**
 * Canonical MessageEventClient implementation.
 *
 * This is the source of truth. `@post-office/message-lifecycle` uses this via
 * `@atlassian/post-office-context/message-lifecycle`.
 */ // ---------------------------------------------------------------------------
// Types (inlined from @post-office/message-lifecycle/src/types.ts)
// ---------------------------------------------------------------------------
var $a0bd139ff1aa714c$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
// ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $a0bd139ff1aa714c$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $a0bd139ff1aa714c$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $a0bd139ff1aa714c$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("1IQCv"));
class $a0bd139ff1aa714c$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $a0bd139ff1aa714c$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $a0bd139ff1aa714c$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $a0bd139ff1aa714c$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($a0bd139ff1aa714c$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $a0bd139ff1aa714c$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $a0bd139ff1aa714c$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["InAppMessageEventType"] = $a0bd139ff1aa714c$export$b31ffc6f7c85f1b;
module.exports["MessageEventClient"] = $a0bd139ff1aa714c$export$ae86a6dabe385178;

});

parcelRegister("aCX5O", function(module, exports) {
$parcel$export(module.exports, "useRecommendationContext", () => (parcelRequire("5pgAV")).useRecommendationContext);
/**
 * Message lifecycle hooks for Post Office headless consumers.
 *
 * Provides `useMessageViewed` — a single hook that fires all three "viewed"
 * analytics events on mount:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed() (message-instance-event endpoint)
 *   - messageInstanceDeliveredSuccessfully() (message-instance-event endpoint)
 *
 * This module is hoisted into @atlassian/post-office-context so that platform
 * packages can consume it without cross-workspace @post-office/* imports.
 *
 * Canonical sources this was inlined from:
 *   post-office/packages/clients/message-lifecycle
 *   post-office/packages/clients/message-instance-event-frontend-client
 *   post-office/packages/clients/recommendation-context
 */ 
var $cpPWT = parcelRequire("cpPWT");

var $PAiZW = parcelRequire("PAiZW");


var $4oTqF = parcelRequire("4oTqF");


var $ei5m0 = parcelRequire("ei5m0");


var $kKtKb = parcelRequire("kKtKb");


var $GHZ06 = parcelRequire("GHZ06");


var $5pgAV = parcelRequire("5pgAV");

const $f8f80c0eb97d668e$export$f847ba3acec566f4 = ()=>{
    // -- message-lifecycle (legacy) client --
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $ei5m0.MessageEventClient)();
    const legacyClient = globalThis.window.postOfficeMessageEventClient;
    // -- message-instance-event client --
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $kKtKb.MessageInstanceEventClient)();
    const instanceClient = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId } = (0, $4oTqF.useMessageContext)();
    const { placementId: placementId } = (0, $GHZ06.usePlacementContext)();
    const browserContext = (0, $PAiZW.usePostOfficeContext)();
    const recommendationContext = (0, $5pgAV.useRecommendationContext)();
    const { markViewedFromPlacement: markViewedFromPlacement } = (0, $cpPWT.useMessagePlacementHooks)();
    return async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) {
            // eslint-disable-next-line no-console
            console.error('[post-office] useMessageViewed: missing required context fields');
            return;
        }
        const sharedContext = {
            ...browserContext,
            source: placementId,
            recommendation: {
                recommendationSessionId: recommendationContext.sessionId ?? '',
                recommendationEntityId: recommendationContext.entityId ?? ''
            }
        };
        // 1. Legacy lifecycle event (messageViewed)
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        legacyClient.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $ei5m0.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: {
                browser: browserContext,
                recommendation: recommendationContext
            }
        });
        // 2. messageInstanceViewed
        await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType ?? 'implicit',
            messageTriggerId: messageTriggerId ?? '',
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
        // 3. messageInstanceDeliveredSuccessfully
        if (messageCreationType && messageTriggerId) await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
    };
};

});

parcelRegister("jC1t2", function(module, exports) {
$parcel$export(module.exports, "noop", () => $e472b457761b7785$export$8793edee2d425525, (v) => $e472b457761b7785$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $e472b457761b7785$export$9c21a3269931e1e6, (v) => $e472b457761b7785$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $e472b457761b7785$export$ba43bf67f3d48107, (v) => $e472b457761b7785$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $e472b457761b7785$export$f84bd70098573c5c, (v) => $e472b457761b7785$export$f84bd70098573c5c = v);
var $e472b457761b7785$export$1e511d4a378977f5;
var $e472b457761b7785$export$8793edee2d425525;
var $e472b457761b7785$export$9c21a3269931e1e6;
var $e472b457761b7785$export$ba43bf67f3d48107;
var $e472b457761b7785$export$f84bd70098573c5c;
"use strict";
$e472b457761b7785$export$1e511d4a378977f5 = true;
$e472b457761b7785$export$8793edee2d425525 = $e472b457761b7785$export$9c21a3269931e1e6 = $e472b457761b7785$export$ba43bf67f3d48107 = $e472b457761b7785$export$f84bd70098573c5c = void 0;
var $e472b457761b7785$var$defaultOptions = $e472b457761b7785$export$ba43bf67f3d48107 = {};
var $e472b457761b7785$var$defaultConfig = $e472b457761b7785$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $e472b457761b7785$var$noop = ()=>{};
$e472b457761b7785$export$8793edee2d425525 = $e472b457761b7785$var$noop;
var $e472b457761b7785$var$defaultProps = $e472b457761b7785$export$9c21a3269931e1e6 = {
    onEnterViewport: $e472b457761b7785$var$noop,
    onLeaveViewport: $e472b457761b7785$var$noop
};

});

parcelRegister("kKtKb", function(module, exports) {
/**
 * Canonical MessageInstanceEventClient implementation (viewed and deliverySuccessful events).
 *
 * This is the source of truth for the viewed/delivered subset of message instance events.
 * The full clicked/created events remain in `@post-office/message-instance-event-frontend-client`.
 */ // ---------------------------------------------------------------------------
// Minimal types (subset of @post-office/shared-contracts/message-instance-event)
// We only need viewed + deliverySuccessful for in-app pull-channel events.
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $89dc3a077779ef60$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $89dc3a077779ef60$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $89dc3a077779ef60$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("1IQCv"));
class $89dc3a077779ef60$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $89dc3a077779ef60$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $89dc3a077779ef60$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $89dc3a077779ef60$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($89dc3a077779ef60$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $89dc3a077779ef60$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $89dc3a077779ef60$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["MessageInstanceEventClient"] = $89dc3a077779ef60$export$4564cfc2de39be55;

});


$parcel$global.rlb("l637W")
//# sourceMappingURL=ShareAndRestrictDialog.657371bb.js.map
